import { LitElement, html, nothing } from 'lit';
import { property, state } from 'lit/decorators.js';
import { customElement } from 'lit/decorators/custom-element.js';
import { style } from './teaser.style';
import {query} from "lit/decorators/query.js";
import {SbkTag} from "@/components/tag/tag.ts";
import './teaser.scss'

@customElement('sbk-teaser')
export class SbkTeaser extends LitElement {

    static shadowRootOptions = {...LitElement.shadowRootOptions, delegatesFocus: true};

    @property({ type: String })
    topic = '';

  @property({type: String})
  headline = '';

  @property({attribute: 'image-format'})
  imageFormat: '16to9' | '3to2' | '1to1' | '4to3' | '5to2' = '16to9';

    @property({attribute: 'image-size'})
    imageSize: 'default' | 'large' = 'default';

  @property({ type: String })
  variant: 'horizontal' | 'horizontal-reverse' | 'vertical' = 'vertical';

  @property()
  href = '';

    @property()
    target?: '_blank' | '_parent' | '_self' | '_top' | '' = '';

  @property({ type: Boolean, attribute: 'no-headline-link' })
  noHeadlineLink = false;

  @query('.teaser__container')
  _teaserContainer!: HTMLDivElement;

  @state()
  hasBodySlot: boolean = false;

    @state()
    hasFooterSlot: boolean = false;

    @state()
    hasFooterRightSlot: boolean = false;

  constructor() {
      super();
      this.addEventListener('click', (e: Event) => {
          if (e.target instanceof SbkTag) {
              return
          }
          if (this.href) {
              e.preventDefault();
              if (this.target === '_blank') {
                  window.open(this.href, '_blank', 'noopener, noreferrer');
              } else {
                  window.location.href = this.href;
              }
          }
      });
  }

  static get styles() {
    return style;
  }


  render() {
    return html`
      <div class="teaser__container ${this.variant}">
          <slot name="image" class="image-container image-slot image-slot--${this.imageFormat} image-slot__size--${this.imageSize}"></slot>
        <div class="content-wrapper">
            ${this._renderHeader()}
            <div class="teaser__content">
                ${this.headline ? html`<div class="headline">
                    <sbk-headline-link href=${this.noHeadlineLink ? '' : this.href} target=${this.target || nothing}>${this.headline}</sbk-headline-link>
                </div>` : nothing}
                <div class="teaser-body" ?hidden=${!this.hasBodySlot}>
                    <slot @slotchange=${this._onBodySlotChange} class="body-slot"></slot>
                </div>
            </div>
            <div class="teaser__footer${!this.hasFooterSlot && !this.hasFooterRightSlot ? ' hidden' : ''}">
                <slot name="footer-slot" class="teaser__footer-slot" @slotchange=${this._onFooterSlotChange}></slot>
                <slot name="footer-right-slot" class="teaser__footer-right-slot" @slotchange=${this._onFooterRightSlotChange}></slot>
            </div>
        </div>
      </div>
    `;
  }

    _onBodySlotChange() {
        const slot: HTMLSlotElement | null = this.renderRoot.querySelector('slot[class=body-slot]');
        if (!slot) {
            return ;
        }
        this.hasBodySlot = !!slot.assignedElements().length;
    }

    _onFooterSlotChange() {
        const slot: HTMLSlotElement | null = this.renderRoot.querySelector('slot[name=footer-slot]');
        if (!slot) {
            return ;
        }
        this.hasFooterSlot = !!slot.assignedElements().length;
    }

  _onFooterRightSlotChange() {
      const slot: HTMLSlotElement | null = this.renderRoot.querySelector('slot[name=footer-right-slot]');
      if (!slot) {
          return ;
      }
      this.hasFooterRightSlot = !!slot.assignedElements().length;
  }

  _renderHeader() {
      if (!this.topic) {
          return '';
      }
      return html`
          <header class="teaser__header">
              <span>${this.topic}</span>
          </header>
      `;
  }
}
